@if (form) {
  <div class="modalForm" [formGroup]="form">
    <div class="flex gap-2 g-col-1-3">
      <h3 class="m-0">{{ "gate_administration.tenant_settings.notification.title" | translate }}</h3>
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="notificationTimeFE">
        {{ "gate_administration.tenant_settings.notification.time_fe" | translate }}
      </label>
      <input
        pInputText
        id="notificationTimeFE"
        formControlName="notificationTimeFE"
        autocomplete="off"
        type="number"
        min="0"
        max="999"
      />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="notificationTimeGuard">
        {{ "gate_administration.tenant_settings.notification.time_guard" | translate }}
      </label>
      <input
        pInputText
        id="notificationTimeGuard"
        formControlName="notificationTimeGuard"
        autocomplete="off"
        type="number"
        min="0"
        max="999"
      />
    </div>
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button [buttonText]="'common.cancel'" (click)="ref.close()" (keydown.enter)="ref.close()"></app-button>
      <app-button
        [loading]="requestStarted()"
        [buttonText]="'common.save'"
        [disabled]="!form.valid || requestStarted()"
        (click)="save()"
        (keydown.enter)="save()"
      ></app-button>
    </div>
  </div>
}
